/* eslint-disable react/destructuring-assignment */
import React, { useContext } from "react";
import { string, arrayOf } from "prop-types";
import moment from "moment";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedAmount from "pages/_components/FormattedAmount";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";

const ReturnSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {}, creationDateTime = moment(), idTransaction = "" } = transaction;
    const { echeqList = props.echeqList, solicitantName = props.solicitantName } = data;
    return (
        <GridTable>
            <GridTable.Container columns={3} rows={1}>
                {idTransaction && (
                    <GridTable.Data columnStart={1} rowStart={1}>
                        <GridTable.Data columnStart={1} rowStart={1}>
                            <GridTable.Container columns={1} rows={2} className="mb-4">
                                <GridTable.Data rowStart={1}>
                                    <CustomText textType="I18N" text="echecks.createdRange.label" />
                                </GridTable.Data>
                                <GridTable.Data rowStart={2}>
                                    <CustomText
                                        textType="DATE"
                                        className="data-label"
                                        text={creationDateTime}
                                        dateFormat="DD/MM/YYYY HH:mm:ss"
                                    />
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} rowStart={1}>
                            <GridTable.Container columns={1} rows={2} className="mb-4">
                                <GridTable.Data rowStart={1}>
                                    <CustomText textType="I18N" text="ticket.voucher" />
                                </GridTable.Data>
                                <GridTable.Data rowStart={2}>
                                    <CustomText
                                        className="data-label"
                                        text={idTransaction.substring(0, 8).toUpperCase()}
                                    />
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable.Data>
                    </GridTable.Data>
                )}
            </GridTable.Container>

            {echeqList?.map((echeq) => (
                <>
                    <GridTable>
                        <GridTable.Container columns={3} rows={5}>
                            <GridTable.Data columnStart={1} rowStart={1}>
                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echecks.number.label" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <CustomText className="data-label" text={echeq.cheque_numero} />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>
                            <GridTable.Data columnStart={2} rowStart={1}>
                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echecks.beneficiary" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <CustomText className="data-label" text={echeq.beneficiario_nombre} />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>
                            <GridTable.Data columnStart={3} rowStart={1}>
                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echecks.document" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <CustomText className="data-label" text={echeq.beneficiario_documento} />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>

                            <GridTable.Data columnStart={1} rowStart={2}>
                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echecks.amount" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <FormattedAmount
                                            className="data-label"
                                            currency={echeq.emisor_moneda}
                                            quantity={echeq.monto}
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>
                            <GridTable.Data columnStart={2} rowStart={2}>
                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echecks.id.label" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <CustomText className="data-label" text={echeq.cheque_id} />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>
                            <GridTable.Data columnStart={3} rowStart={2}>
                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                    <GridTable.Container columns={1} rows={1} className="mb-4">
                                        <GridTable.Data rowStart={1}>
                                            <CustomText textType="I18N" text="echecks.echeckType" />
                                        </GridTable.Data>
                                        <GridTable.Data rowStart={2}>
                                            <CustomText className="data-label" text={echeq.cheque_tipo} />
                                        </GridTable.Data>
                                    </GridTable.Container>
                                </GridTable.Container>
                            </GridTable.Data>

                            <GridTable.Data columnStart={1} rowStart={3}>
                                <GridTable.Container columns={1} rows={1} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echecks.echeckMode" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <CustomText
                                            textType="I18N"
                                            className="data-label"
                                            text={
                                                echeq.cheque_modo === 1 ? "echecks.emit.cross" : "echecks.emit.uncross"
                                            }
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>
                            <GridTable.Data columnStart={2} rowStart={3}>
                                <GridTable.Container columns={1} rows={1} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echecks.createdRange.label" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <CustomText textType="DATE" className="data-label" text={echeq.fecha_emision} />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>
                            <GridTable.Data columnStart={3} rowStart={3}>
                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echecks.echeckNature" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <CustomText className="data-label" text={echeq.cheque_caracter} />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>

                            <GridTable.Data columnStart={1} rowStart={4}>
                                <GridTable.Container columns={1} rows={1} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echecks.payedRange.label" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <CustomText textType="DATE" className="data-label" text={echeq.fecha_pago} />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>
                            <GridTable.Data columnStart={2} rowStart={4}>
                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echecks.echeckConcept" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <CustomText
                                            textType="I18N"
                                            className="data-label"
                                            text={`transfer.reasons.${echeq.cheque_concepto}`}
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>

                            <GridTable.Data columnStart={3} rowStart={4}>
                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echecks.emit.motive.label" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <CustomText className="data-label" text={echeq.cheque_motivo_pago} />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>

                            <GridTable.Data columnStart={1} rowStart={5}>
                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echeq.request.return.cuit" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <CustomText className="data-label" text={echeq.cuit_solic_devol} />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>
                            <GridTable.Data columnStart={2} rowStart={5}>
                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echeqs.emit.reference.beneficiary" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <CustomText className="data-label" text={solicitantName} />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable>
                </>
            ))}
        </GridTable>
    );
};

ReturnSummaryBody.propTypes = {
    solicitantName: string,
    echeqList: arrayOf(echeqPropTypes),
};

ReturnSummaryBody.defaultProps = {
    solicitantName: "",
    echeqList: [],
};

export default ReturnSummaryBody;
